// 企业中心  代理  同行代理
import axios from "../../../untils/request.js";
// 查看评价
export async function getEvaluation(data) {
    const res = await axios({
      method: "post",
      url: "/global/evaluation/getEvaluation",
      intercept: 1,
      data,
      headers: {
        "Content-Type": "application/json", //设置请求头请求格式为JSON
      },
    });
    return res;
  }
  // 添加评价
  export async function addEvaluation(data) {
    const res = await axios({
      method: "post",
      url: "/global/evaluation/addEvaluation",
      intercept: 1,
      data,
      headers: {
        "Content-Type": "application/json", //设置请求头请求格式为JSON
      },
    });
    return res;
  }